import { render, staticRenderFns } from "./contact-dialog.vue?vue&type=template&id=71d813c0&scoped=true&"
import script from "./contact-dialog.vue?vue&type=script&lang=js&"
export * from "./contact-dialog.vue?vue&type=script&lang=js&"
import style0 from "./contact-dialog.vue?vue&type=style&index=0&id=71d813c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d813c0",
  null
  
)

export default component.exports